import { resolveInteractiveRoomUrl } from '@interactive-room';

export interface WikiImageCandidate {
  url: string;
  title?: string;
  source: 'commons' | 'wikipedia';
}

export async function listWikiImageCandidates(
  query: string,
  limit = 12,
  baseUrl?: string,
): Promise<WikiImageCandidate[]> {
  const q = String(query || '').trim();
  if (!q) return [];
  const url = new URL(`${resolveInteractiveRoomUrl(baseUrl)}/api/guides/wiki-images`);
  url.searchParams.set('q', q);
  url.searchParams.set('limit', String(limit));
  const resp = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
  const data = (await resp.json().catch(() => null)) as {
    ok?: boolean;
    candidates?: WikiImageCandidate[];
    error?: string;
  } | null;
  if (!resp.ok || !data?.ok) {
    throw new Error(data?.error || 'wiki_images_failed');
  }
  return Array.isArray(data.candidates) ? data.candidates : [];
}
